var drawer = function () {
    /**
    * Element.closest() polyfill
    * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
    */
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }

    //
    // Settings
    //
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
    };

    //
    // Methods
    //
    // Toggle accessibility
    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };
    // Open Drawer
    var openDrawer = function (trigger) {

      if($('div[aria-labelledby="added-to-cart-title"]').hasClass('reveal')){
        setCookie("IsRefresh", "true", 1);
          location.reload();
      }else{
          // Find target
          var target = document.getElementById(trigger.getAttribute('aria-controls'));
          // Make it active
          target.classList.add(settings.activeClass);
          // Make body overflow hidden so it's not scrollable
          document.documentElement.style.overflow = 'hidden';
          // Toggle accessibility
          toggleccessibility(trigger);
          // Make it visible
          setTimeout(function () {
            target.classList.add(settings.visibleClass);
          }, settings.speedOpen);
      }
    };
    // Close Drawer
    var closeDrawer = function (event) {
      // Find target
      var url = window.location.toString();
		//window.location = url.replace('?cart=true', '');
      window.history.pushState('', '', url.replace('?cart=true', ''));
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      // Make it not visible
      closestParent.classList.remove(settings.visibleClass);
      // Remove body overflow hidden
      document.documentElement.style.overflow = '';
      // Toggle accessibility
      toggleccessibility(childrenTrigger);
      // Make it not active
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
    };
    // Click Handler
    var clickHandler = function (event) {
      // Find elements
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);
      // Open drawer when the open button is clicked
      if (open) {
        openDrawer(open);
      }
      // Close drawer when the close button (or overlay area) is clicked
      if (close) {
        closeDrawer(close);
      }
      // Prevent default link behavior
      if (open || close) {
        event.preventDefault();
      }
    };
    // Keydown Handler, handle Escape button
    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Find all possible drawers
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        // Find active drawers and close them when escape is clicked
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    //
    // Inits & Event Listeners
    //
    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);

   function setCookie(c_name, value, exdays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
            document.cookie = c_name + "=" + c_value;
        }

};
drawer();
//accesibility fix js
document.addEventListener('DOMContentLoaded', function() {
const closeBtn = document.querySelector('.drawer__close[data-drawer-close]');
if (closeBtn) {
  closeBtn.innerHTML = '<svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20"><line x1="4" y1="4" x2="16" y2="16" stroke="black" stroke-width="2"/><line x1="16" y1="4" x2="4" y2="16" stroke="black" stroke-width="2"/></svg>';
  closeBtn.setAttribute('aria-label', 'Close cart');
}

var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
var drawer = document.getElementById('drawer-name');
if (!drawer) return;

function getFocusable() {
  var wrapper = drawer.querySelector('.drawer__wrapper');
  if (!wrapper) return [];
  return [...wrapper.querySelectorAll(FOCUSABLE)];
}

function isDrawerOpen() {
  return drawer.classList.contains('is-active') || drawer.classList.contains('is-visible');
}

function focusDrawer() {
  setTimeout(function() {
    var focusable = getFocusable();
    if (focusable.length) focusable[0].focus();
  }, 200);
}
var wasOpen = false;
new MutationObserver(function() {
  var isOpen = isDrawerOpen();
  if (isOpen && !wasOpen) {
    focusDrawer();
  }
  wasOpen = isOpen;
}).observe(drawer, { attributes: true, attributeFilter: ['class'] });

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Tab') return;
  if (!isDrawerOpen()) return;

  var focusable = getFocusable();
  if (!focusable.length) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault();
      last.focus();
      last.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  } else {
    if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
      first.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

setTimeout(function() {
  var active = document.activeElement;
  if (!active || active === document.body) return;

  var drawerContent = drawer.querySelector('.overflow_data');
  if (!drawerContent) return;

  var activeRect = active.getBoundingClientRect();
  var contentRect = drawerContent.getBoundingClientRect();
  if (activeRect.bottom > contentRect.bottom) {
    drawerContent.scrollTop += (activeRect.bottom - contentRect.bottom) + 20;
  }
  if (activeRect.top < contentRect.top) {
    drawerContent.scrollTop -= (contentRect.top - activeRect.top) + 20;
  }
}, 50);
});
var IsRefresh = getCookie('IsRefresh');
if (IsRefresh != null && IsRefresh != '') {
  $('.drawer').addClass('is-active');
  $('.drawer').addClass('is-visible');
  DeleteCookie('IsRefresh');
  focusDrawer();
}
});

function getCookie(c_name) {
var ARRcookies = document.cookie.split(';');
for (var i = 0; i < ARRcookies.length; i++) {
  var x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('=')).replace(/^\s+|\s+$/g, '');
  var y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
  if (x == c_name) return unescape(y);
}
}

function DeleteCookie(name) {
document.cookie = name + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
}
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerContent = document.getElementById("cart__drawer");

  if (cartDrawerContent) {
    const checkEmptiness = () => {
      // Looks for common Shopify "empty cart" indicators inside your specific drawer layout
      const hasEmptyText = cartDrawerContent.querySelector('.rte p.align-center, [data-empty-cart-message], .cart-drawer__empty-text');
      const hasLineItems = cartDrawerContent.querySelector('.cart-list, .line_total');

      if (hasEmptyText || !hasLineItems) {
        cartDrawerContent.classList.add("is-empty");
      } else {
        cartDrawerContent.classList.remove("is-empty");
      }
    };

    // Run the initial check right away when the page/drawer loads
    checkEmptiness();

    // Set up an observer to watch for dynamic changes (adding/removing items via AJAX)
    const observer = new MutationObserver(checkEmptiness);
    observer.observe(cartDrawerContent, {
      childList: true,
      subtree: true
    });
  }
});